import React,{useState} from 'react';
import PropTypes from 'prop-types';
import { lighten, makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import Tooltip from '@material-ui/core/Tooltip';
import TextField from '@material-ui/core/TextField';
import EditIcon from "@material-ui/icons/Edit";
import { CSVLink } from "react-csv";
import moment from 'moment';
import Button from '@material-ui/core/Button';
import Modal from '@material-ui/core/Modal';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import CloseIcon from '@material-ui/icons/Close';

function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}

function getComparator(order, orderBy) {
    return order === 'desc'
        ? (a, b) => descendingComparator(a, b, orderBy)
        : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
}

const headCells = [
    { id: 'campaignId', disablePadding: true, label: 'Campaign Id'},
    { id: 'campaignName', disablePadding: true, label: 'Campaign Name'},
    { id: 'consumerId', disablePadding: true, label: 'Consumer Id'},
    { id: 'consumerName', disablePadding: true, label: 'Consumer Name'},
    { id: 'mobileNumber', disablePadding: true, label: 'Mobile No.' },
    { id: 'dateOfRegistration', disablePadding: true, label: 'Registered Date'},
    { id: 'promoCode', disablePadding: false, label: 'Promocode' },
    { id: 'couponGenerated', disablePadding: false, label: 'Coupon Generated' },
    { id: 'ordersAtXirify', disablePadding: false, label: 'Orders on Xirify' },
    { id: 'societyName', disablePadding: true, label: 'Society Name'},
    { id: 'streetName', disablePadding: true, label: 'Street Name'},
    { id: 'area', disablePadding: false, label: 'Area'},
    { id: 'pinCode', disablePadding: false, label: 'Pincode' },
    { id: 'city', disablePadding: false, label: 'City' },
    // { id: 'state', disablePadding: false, label: 'State' },
];

function EnhancedTableHead(props) {
    const { classes, order, orderBy, onRequestSort , brandName} = props;
    const createSortHandler = (property) => (event) => {
        onRequestSort(event, property);
    };

    return (
        <TableHead>
            <TableRow>
                {headCells.map((headCell) => (
                    <TableCell
                        key={headCell.id}
                        align={headCell.numeric ? 'right' : 'left'}
                        sortDirection={orderBy === headCell.id ? order : false}
                        className={classes.tableCellSmall}
                    >
                        <TableSortLabel
                            active={orderBy === headCell.id}
                            direction={orderBy === headCell.id ? order : 'asc'}
                            onClick={createSortHandler(headCell.id)}
                        >
                            {headCell.label === 'Orders on Xirify' ? 'Orders on '+brandName : headCell.label }
                            {orderBy === headCell.id ? (
                                <span className={classes.visuallyHidden}>
                                    {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                                </span>
                            ) : null}
                        </TableSortLabel>
                    </TableCell>
                ))}
            </TableRow>
        </TableHead>
    );
}

EnhancedTableHead.propTypes = {
    classes: PropTypes.object.isRequired,
    onRequestSort: PropTypes.func.isRequired,
    order: PropTypes.oneOf(['asc', 'desc']).isRequired,
    orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired,
};

const useToolbarStyles = makeStyles((theme) => ({
    root: {
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(1),
    },
    highlight:
        theme.palette.type === 'light'
            ? {
                color: theme.palette.secondary.main,
                backgroundColor: lighten(theme.palette.secondary.light, 0.85),
            }
            : {
                color: theme.palette.text.primary,
                backgroundColor: theme.palette.secondary.dark,
            },
    title: {
        flex: '1 1 100%'
    },
}));

const EnhancedTableToolbar = (props) => {
    const classes = useToolbarStyles();
    let csvData = []
    props.data.forEach(element => {
        let obj = element
        obj.createdAt = (moment(obj.createdAt).format('DD MMM YYYY hh:mm A'))
        csvData.push(obj)
    });

    return (
        <Toolbar style={{ paddingLeft: "16px" }}>
            <Typography className={classes.title} variant="subtitle2" id="tableTitle" component="div">
                Promo Code Report ({props.total})
            </Typography>

            <Typography component="div">
                {props.showDownloadIcon ?
                    <CSVLink
                        data={csvData}
                        headers={props.headers}
                        filename={"promocode_report.csv"}
                        className="btn btn"
                        target="_blank"
                    >
                        <Tooltip title="Export to Excel">
                            <img alt="Export To Excel" src="../../images/exportToExcel.png" width="25" height="25" />
                        </Tooltip>
                    </CSVLink>
                    :
                    <Button
                        variant="contained"
                        margin="normal"
                        style={{ backgroundColor: "green", color: "white", fontFamily: "bold" }}
                        onClick={props.fetchPromocodesExcelFile}
                    >
                        Export
                </Button>
                }
            </Typography>
        </Toolbar>
    );
};

/* EnhancedTableToolbar.propTypes = {
    exportToExcel: PropTypes.func.exportToExcel,
    total: PropTypes.number.isRequired
}; */

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
    },
    paper: {
        width: '100%',
        marginBottom: theme.spacing(2),
    },
    table: {
        minWidth: 750,
    },
    visuallyHidden: {
        border: 0,
        clip: 'rect(0 0 0 0)',
        height: 1,
        margin: -1,
        overflow: 'hidden',
        padding: 0,
        position: 'absolute',
        top: 20,
        width: 1,
    },
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120,
    },
    tableCellSmall: {
        fontSize: "12px",
        padding: "6px 0px 6px 16px"
    },
    tableRow: {
        // cursor: 'pointer'
    },
    small: {
        width: theme.spacing(3),
        height: theme.spacing(3),
    },
    modal: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '0px'
    },
      modalContainer: {
        width: '50%',
        height: '35%',
        backgroundColor: theme.palette.background.paper,
        padding: '15px',
    },
}));

export default function EnhancedTable(props) {
    const classes = useStyles();

    const handlePromocodesSort = (event, property) => {
        const isAsc = props.orderBy === property && props.order === 'asc';
        props.setOrder(isAsc ? -1 : 1);
        props.setOrderBy(property);
    };

    const handleChangePage = (event, newPage) => {
        props.setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        props.setRowsPerPage(parseInt(event.target.value, 10));
        props.setPage(0);
    };

    let headers = [
        { key: 'campaignIdText', label: 'Campaign Id'},
        { key: 'campaignNameText', label: 'Campaign Name'},
        { key: 'consumerId', label: 'Consumer Id'},
        { key: 'consumerName', label: 'Consumer Name'},
        { key: 'mobileNumber', label: 'Mobile No.' },
        { key: 'dateOfRegistration', label: 'Registered Date'},
        { key: 'promoCode', label: 'Promocode'},
        { key: 'couponGenerated', label: 'Coupon Generated'},
        { key: 'ordersAtXirify', label: 'Orders on Xirify' },
        { key: 'societyName', label: 'Society Name'},
        { key: 'streetName', label: 'Street Name'},
        { key: 'area', label: 'Area'},
        { key: 'pinCode', label: 'Pincode'},
        { key: 'city', label: 'City'},
        // { key: 'state', label: 'State'},
    ];
    let data = props.data;
    data.exportData && data.exportData.forEach(item => {
        item.campaignIdText=item.campaignId && item.campaignId[0]?item.campaignId[0].campaignId:"";
        item.campaignNameText=item.campaignId && item.campaignId[0]?item.campaignId[0].campaignName:"";
        /* eslint-disable no-self-assign */
        item.consumerId=item.consumerId;
        item.mobileNumber=item.primaryMobileNumber;
        item.promoCode=item.promoCode;
        /* eslint-enable no-self-assign */
        if(item.firstName&&item.lastName){
            item.consumerName=item.firstName+" "+ item.lastName;
        } else {
            item.consumerName=""
        }
        item.dateOfRegistration=item.createdAt;
        item.couponGenerated=item.campaignId && item.campaignId[0] && item.campaignId[0].campaignId?"true":"false";
        let address = item.address && item.address.length>0&& item.address.filter((item)=>{
            return item.isDefaultAddress
        })[0]
        item.societyName=address && address.societyName ?address.societyName:"";
        item.streetName=address && address.street ?address.street:"";
        item.area=address && address.area ?address.area:"";
        item.pinCode=address && address.pinCode ?address.pinCode:"";
        item.city=address && address.city ?address.city:"";
    });

    const emptyRows = props.rowsPerPage - Math.min(props.rowsPerPage, props.data.totalCount - props.page * props.rowsPerPage);
    
    const [isModalOpen,setIsModalOpen]=useState(false);
    const [selectedId,setSelectedId]=useState("");
    const [selectedConsumerId,setSelectedConsumerId]=useState("");
    const [selectedConsumerName,setSelectedConsumerName]=useState("");
    const [selectedConsumerMobileNo,setSelectedConsumerMobileNo]=useState("");
    const [selectedPromoCode,setSelectedPromoCode]=useState("");

    const handleModalOpen = () => {
        setIsModalOpen(true)
    }
    
    const handleModalClose = () => {
        setIsModalOpen(false)
        setSelectedId("")
        setSelectedConsumerId("")
        setSelectedConsumerName("")
        setSelectedConsumerMobileNo("")
        setSelectedPromoCode("")
    }
    const onEditButtonClick=(data)=>{
        setSelectedId(data._id)
        setSelectedConsumerId(data.consumerId?data.consumerId:"")
        if(data.firstName && data.lastName){
            setSelectedConsumerName(data.firstName+" "+data.lastName)    
        } else {
            setSelectedConsumerName("")
        }
        setSelectedConsumerMobileNo(data.primaryMobileNumber?data.primaryMobileNumber:"")
        handleModalOpen()
    }
    const onSaveButtonClick=()=>{
        props.assignCouponValueToItem(selectedPromoCode,selectedId)
        handleModalClose()
    }
    
    return (
        <div className={classes.root}>
            <Modal 
            className={classes.modal}
            open={isModalOpen}
            onClose={()=>handleModalClose()}
            closeAfterTransition>
              <Container className={classes.modalContainer}>
              <Grid container style={{backgroundColor:"primary"}} spacing={3}>
                    <Grid item xs={8}>
                        <Typography variant="subtitle3" gutterBottom>
                            Add Promo Code
                        </Typography>
                    </Grid>
                    <Grid item xs={4}>
                        <CloseIcon style={{float:"right"}} onClick={() => handleModalClose()}/>
                    </Grid>
             </Grid>

            <Grid container style={{backgroundColor:"primary"}} spacing={3}>

                    <Grid item xs={3}>
                        <Typography variant="subtitle" gutterBottom>
                            Consumer Id
                        </Typography>
                    </Grid>
                    <Grid item xs={3}>
                        <Typography variant="subtitle" gutterBottom>
                            Consumer Name 
                        </Typography>
                    </Grid>
                    <Grid item xs={3}>
                        <Typography variant="subtitle" gutterBottom>
                            Consumer Mobile No.
                        </Typography>
                    </Grid>
                    <Grid item xs={3}>
                        <Typography variant="subtitle" gutterBottom>
                            Promo Code
                        </Typography>
                    </Grid>
                </Grid>
                 <Grid container style={{backgroundColor:"primary"}} spacing={3}>

                    <Grid item xs={3}>
                        <Typography variant="subtitle" gutterBottom>
                            {selectedConsumerId}
                        </Typography>
                    </Grid>
                    <Grid item xs={3}>
                        <Typography variant="subtitle" gutterBottom>
                            {selectedConsumerName}
                        </Typography>
                    </Grid>
                    <Grid item xs={3}>
                        <Typography variant="subtitle" gutterBottom>
                            {selectedConsumerMobileNo}
                        </Typography>
                    </Grid>
                    <Grid item xs={3}>
                        <TextField fullWidth margin="dense" value={selectedPromoCode} variant="outlined" 
                        onChange={(e)=>{setSelectedPromoCode(e.target.value.toUpperCase())}} />
                    </Grid>
                </Grid>
                <Grid container style={{backgroundColor:"primary"}} spacing={3}>
                    <Grid item xs={8}></Grid>
                    <Grid item xs={4}>
                     <Button
                        type="submit"
                        fullWidth
                        variant="contained"
                        margin="normal"
                        color="primary"
                        onClick={()=>{onSaveButtonClick()}}
                    >
                        Save
                    </Button>
                    </Grid>
                </Grid>
              </Container>
          </Modal>
            <Paper className={classes.paper}>
                <EnhancedTableToolbar
                    total={props.data.totalCount}
                    headers={headers}
                    data={props.data.exportData}
                    // data={props.data.exportToExcel}
                    showDownloadIcon={props.showDownloadIcon}
                    fetchPromocodesExcelFile={props.fetchPromocodesExcelFile}

                />
                <TableContainer>
                    <Table
                        className={classes.table}
                        aria-labelledby="tableTitle"
                        size="small"
                        aria-label="enhanced table"
                    >
                        <EnhancedTableHead
                            classes={classes}
                            order={props.order}
                            orderBy={props.orderBy}
                            onRequestSort={handlePromocodesSort}
                            rowCount={props.data.totalCount}
                            bandName={props.brandName}
                        />
                        <TableBody>
                            {stableSort(props.data.consumerData, getComparator(props.order, props.orderBy))
                                // .slice(props.page * props.rowsPerPage, props.page * props.rowsPerPage + props.rowsPerPage)
                                .map((row, index) => {
                                    const labelId = `enhanced-table-checkbox-${index}`;
                                    let firstName=row.firstName || null;
                                    let lastName=row.lastName || null;
                                    let address = row.address && row.address.length>0&& row.address.filter((item)=>{
                                        return item.isDefaultAddress
                                    })[0]

                                    return (
                                        <TableRow
                                            hover
                                            className={classes.tableRow}
                                            role="checkbox"
                                            tabIndex={-1}
                                            key={row._id+index}
                                        >
                                            <TableCell align="left" >{row.campaignId&& row.campaignId.length>0?row.campaignId[0].campaignId:"NA"}</TableCell>
                                            <TableCell align="left" >{row.campaignId&& row.campaignId.length>0?row.campaignId[0].campaignName:"NA"}</TableCell>
                                            <TableCell align="left"  >{row.consumerId?row.consumerId:"NA"}</TableCell>
                                            <TableCell component="th" id={labelId} scope="row">{firstName && lastName ?firstName + " " + lastName:"NA"}</TableCell>
                                            <TableCell align="left" >{row.primaryMobileNumber?row.primaryMobileNumber:"NA"}</TableCell>
                                            <TableCell align="left">{row.createdAt?moment(row.createdAt).format('DD MMM YYYY hh:mm A'):"NA"}</TableCell>
                                            <TableCell align="left"  >
                                                {props.user.role==="admin"?
                                                <div style={{display:"flex", flexDirection:"row",alignItems:"flex-end"}}>
                                                   {row.promoCode?row.promoCode:"No Coupon"}
                                                    {row.campaignId&& row.campaignId.length>0&&row.campaignId[0].campaignId?
                                                    null:<EditIcon color='primary' style={{marginLeft:"10px"}} onClick={()=>{onEditButtonClick(row)}}></EditIcon>}
                                                    </div>
                                                   :(row.promoCode?row.promoCode:"NA")}
                                            </TableCell>
                                            <TableCell align="left"  >{row.campaignId && row.campaignId.length>0 && row.campaignId[0].campaignId?"Yes":"No"}</TableCell>
                                            <TableCell align="left" >{row.ordersAtXirify || "NA"}</TableCell>
                                            <TableCell align="left" >{address && address.societyName?address.societyName:"NA"}</TableCell>
                                            <TableCell align="left" >{address && address.street?address.street:"NA"}</TableCell>
                                            <TableCell align="left" >{address && address.area?address.area:"NA"}</TableCell>
                                            <TableCell align="left" >{address && address.pinCode?address.pinCode:"NA"}</TableCell>
                                            <TableCell align="left" >{address && address.city?address.city:"NA"}</TableCell>
                                            {/* <TableCell align="left" >{row.address.length>0?row.address[0].state:""}</TableCell> */}
                                            
                                        </TableRow>
                                    );
                                })}
                            {emptyRows > 0 && (
                                <TableRow style={{ height: 33 * emptyRows }}>
                                    <TableCell colSpan={6} />
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
                <TablePagination
                    rowsPerPageOptions={[5, 10, 15, 20, 25, 30]}
                    component="div"
                    count={props.data.totalCount}
                    rowsPerPage={props.rowsPerPage}
                    page={props.page}
                    onChangePage={handleChangePage}
                    onChangeRowsPerPage={handleChangeRowsPerPage}
                />
            </Paper>
        </div>
    );
}